import React from 'react'
import './deleteNewPartRequestPNModal.css'

export const DeleteNewPartRequestPNModal = ({ pn, category, deletePn, onClose }) => {
    const handlePN = () => { 
        deletePn()
        onClose()
    }
    return (
        <section className='delete-newpart-tc-cont'>
            <h3>Are you sure you want to  <br /> delete this PN?</h3>
            <div className="delete-newpart-tc-pCont">
                <p>PN: <span>{pn ? pn : "--"}</span></p>
                <div>
                    <p >Category:</p>
                    {/* <Tooltip title={TCDescription} arrow> */}
                    <p >{category}</p>
                    {/* </Tooltip> */}

                </div>
            </div>
            <div className='delete-newpart-tc-btnCont'>
                <button onClick={handlePN}>Ok</button>
                <button onClick={onClose}>Cancel</button>
            </div>
        </section>
    )
}
